import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlReceita = '/service/contabilidade/transparencia/receita/'

class ExerciciosReceitaArrecadadaService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getExercicios() {
        return this.conex.get(urlReceita + 'exerciciosReceitaArrecadada/')
    }
}

export default ExerciciosReceitaArrecadadaService
